jQuery(function ($) {
  //スライダー
  const swiperIntro = new Swiper(".js-swiper-intro", {
    slidesPerView: 4,
    spaceBetween: 40,
    centeredSlides: true,
    loop: true,
    speed: 500,
    freeMode: true,
    freeModeMomentum: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      691: {
        slidesPerView: 2,
      },
      1080: {
        slidesPerView: 4,
      },
    }
  });

  const swiperRecommend = new Swiper(".js-swiper-recommend", {
    slidesPerView: 3,
    spaceBetween: 10,
    slidesPerGroup: 1,
    autoHeight: true,
    breakpoints: {
      300: {
        slidesPerView: 1.5,
      },
      1080: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });

  // タグの種類別
  $(function () {
    $(".js-tag .anc").each(function () {
      let valueLabel = $(this).text();
      switch (true) {
        case /Anker/.test(valueLabel):
          $(this).parent().addClass("is-anker");
          break;
        case /Soundcore/.test(valueLabel):
          $(this).parent().addClass("is-soundcore");
          break;
        case /Nebula/.test(valueLabel):
          $(this).parent().addClass("is-nebula");
          break;
        case /Eufy/.test(valueLabel):
          $(this).parent().addClass("is-eufy");
          break;
        case /Pickups/.test(valueLabel):
        case /Recommend/.test(valueLabel):
        case /Ranking/.test(valueLabel):
          $(this).parent().addClass("is-hidden");
          break;

        default:
          $(this).parent().addClass("is-other");
          break;
      }
    });
  });

  // タグフィルター
  $(function () {
    $(".js-filter .js-tag .anc").each(function () {
      let valueLabel = $(this).text();
      switch (true) {
        case /Anker/.test(valueLabel):
          $(this).parents(".m-PostItem").addClass("Anker");
          break;
        case /Soundcore/.test(valueLabel):
          $(this).parents(".m-PostItem").addClass("Soundcore");
          break;
        case /Nebula/.test(valueLabel):
          $(this).parents(".m-PostItem").addClass("Nebula");
          break;
        case /Eufy/.test(valueLabel):
          $(this).parents(".m-PostItem").addClass("Eufy");
          break;

        default:
          break;
      }
    });

    // 過去の記事を見る
    const moreTrg = $(".js-more");
    let moreItems = $('.js-more-content .m-PostItem');
    moreItems.slice(6).addClass('is-more-hide');


    moreTrg.click(function () {
      if ($(this).hasClass('is-open')) {
        $(this).removeClass("is-open");
        $('.js-more-content .m-PostItem:not(.is-hide)').slice(6).addClass('is-more-hide');
        
      } else {
        $(this).addClass("is-open");
        $('.js-more-content .m-PostItem:not(.is-hide)').slice(6).removeClass('is-more-hide');
      }
    });

    $('.js-filterTrg input').change(function() {
      let checkedItems = $('.js-filterTrg input:checked').val();
      $(".js-filter .m-PostItem").removeClass('is-hide');
      
      $(".js-filter .m-PostItem").each(function () {
        if (!$(this).hasClass(checkedItems)) {
          $(this).addClass('is-hide');
        }
      });

      // 過去の記事を見る動作の補完
      let moreItems = $('.js-more-content .m-PostItem:not(.is-hide)');

      moreItems.slice(6).addClass('is-more-hide');
      if (moreTrg.hasClass('is-open')) {
        moreTrg.removeClass("is-open");
      }
      moreItems.removeClass('is-more-hide');
      moreItems.slice(6).addClass('is-more-hide');
      if(moreItems.length < 7) {
        $(".js-more").hide();
      } else {
        $(".js-more").show();
      }

    });

  });
  

  //目次
  $(function () {
    let counter = 1;
    $(".post-content h2").each(function () {
      let toclink = "toclink" + counter;
      $(this).attr("id", toclink);
      let toctext = $(this).text();
      let element = "<li><a href='#" + toclink + "'>" + toctext + "</a></li>";
      $(".js-toc ul").append(element);
      counter++;
    });
  });

  // スムーススクロール
  $(function () {
    $('a[href^="#"]').click(function () {
      var speed = 800;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  });

  //記事がない場合
  $(function () {
    $(".js-blog-list").removeClass("is-none");
    if (!$(".js-blog-list article").length) {
      $(".js-blog-list")
        .addClass("is-none")
        .append('<article style="text-align:center">No Results</article>');
    }
  });
});
